// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Spacer,
  Text,
  Switch,
  ButtonGroup,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Link,
  Image,
  useColorMode,
  useColorModeValue,
  useDisclosure,
  Modal,
  ModalBody,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalFooter
} from "@chakra-ui/react";
// Assets
import { Scrollbars } from 'react-custom-scrollbars';
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import IconBox from "components/Icons/IconBox";
import { MastercardIcon, VisaIcon } from "components/Icons/Icons";
import { HSeparator } from "components/Separator/Separator";
import BillingRow from "components/Tables/BillingRow";
import RoomRow from "components/Tables/RoomRow";
import MusicRow from "components/Tables/MusicRow";
import Feed from "components/Feeds/Feed";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
var moment = require('moment-jalaali')
import config from "config/index";

import {
  FaPaypal,
  FaPencilAlt,
  FaRegCalendarAlt,
  FaWallet,
  FaLandmark,
  FaMoon,
  FaRocket,
} from "react-icons/fa";
import { RiPlayFill, RiPauseMiniLine, RiArrowLeftSLine, RiDeleteBin3Fill, RiSettings3Fill, RiCheckboxCircleFill, RiVipCrown2Fill, RiMusic2Fill, RiLayoutTop2Fill, RiNewspaperFill, RiChat1Fill, RiMenuLine, RiMoonClearFill, RiRemoteControl2Fill, RiRocketFill, RiArrowRightSLine, RiShareLine, RiFileCopyLine, RiCodeLine } from "react-icons/ri";
import {
  roomTableData,
  musics,
} from "variables/general";

import roomData from "variables/room";
import NiceButton from "components/NiceButton/NiceButton.js";
import allTour from "api/tours/all-tours";
import editTour from "api/tours/edit-tour";
import deleteTour from "api/tours/delete-tour";
import allLanding from "api/landing/all-landing";
import editLanding from "api/landing/edit-landing";
import { ToastContainer, toast } from 'react-toastify';
import allRoom from "api/room/all-room";
import createRoom from "api/room/create-room";
import allFiles from "api/filemanager/all-files";
import { useHistory, useLocation } from "react-router-dom";
import { getGlobal, setGlobal } from "config/global";

function TourDetails() {
const history = useHistory();
  // Chakra color mode
  const { id: address } = useParams()
  let me = getGlobal("me")
  console.log(me)
  const iconBlue = useColorModeValue("blue.500", "blue.500");
  const iconBgColor = useColorModeValue("gray.100", "navy.700");
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("#dee2e6", "transparent");
  const widgetBg = useColorModeValue("gray.50", "navy.800");
  const widgetHoverBg = useColorModeValue("blue.50", "blue.900");
  const widgetIconBg = useColorModeValue("white", "navy.700");
  const { colorMode } = useColorMode();
  const [landingStatus, setLandingStatus] = useState(false);
  const [nightStatus, setNightStatus] = useState(false);
  const [controlPanelStatus, setControlPanelStatus] = useState(false);
  const [galleryStatus, setGalleryStatus] = useState(false);
  const [tourData, setTourData] = useState({});
  const [title, setTitle] = useState("");
  const [home, setHome] = useState("");
  const [lang, setLang] = useState("pr");
  const [rooms, setRooms] = useState("");
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [isSaveLangLoading, setIsSaveLangLoading] = useState(false);
  const [choosedMusic, setChoosedMusic] = useState([]);
  const [isDeleteTourLoading, setIsDeleteTourLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isRoomOpen, onOpen: onRoomOpen, onClose: onRoomClose } = useDisclosure()
  const { isOpen: isMusicOpen, onOpen: onMusicOpen, onClose: onMusicClose } = useDisclosure()
  const { isOpen: isFeedOpen, onOpen: onFeedOpen, onClose: onFeedClose } = useDisclosure()
  const [isCreateRoomLoading, setIsCreateRoomLoading] = useState(false);
  const [roomTitle, setRoomTitle] = useState("");
  const [roomReload, setRoomReload] = useState("");
  const [landingReload, setLandingReload] = useState("");
  const [musics, setMusics] = useState("");
  const [currentMusic, setCurrentMusic] = useState(null);
  const [reloadTour, setReloadTour] = useState("");
  const [feedData, setFeedData] = useState("");
  function feedSubmit() {
    feedData.list.map(item => {
      if (item.href == "")
        item.href = "#"
    })
    editTour(address, {
      "feed": feedData
    }).then((result) => {
      onFeedClose()
      setReloadTour(!reloadTour)
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }
  function playaction(music) {
    if (currentMusic) {
      currentMusic.new.pause()
    }
    if (!currentMusic || currentMusic._id != music._id) {
      music.new = new Audio(config.host + (music.path.replace("upload/user/", "/assets/users/")))
      music.new.play()
      setCurrentMusic(music)
      setGlobal({
        music
      })
    } else {
      setCurrentMusic(null)
    }
  }
  function stopMusic() {
    let current = getGlobal("music")
    if (current) {
      current.new.pause()
      setGlobal({
        music: null
      })
      setCurrentMusic(null)

    }
  }
  useEffect(() => {
    history.listen(stopMusic);
    allTour(address).then((result) => {
      let tour = result.data
      if (!tour) return;
      setControlPanelStatus(tour.controlPanel)
      setNightStatus(tour.night)
      setGalleryStatus(tour.gallery)
      setTitle(tour.title)
      setHome(tour.home ? tour.home : config.host)
      setLang(tour.lang ? tour.lang : "pr")
      setTourData(tour)

      if (tour.music)
        setChoosedMusic([{
          _id: "loaded",
          name: tour.music.filename,
          date: tour.music.date,
          path: tour.music.path
        }])
      else {
        setChoosedMusic([])
      }
    })
      .catch((err) => {
        console.error(err)
        if (err?.response?.data?.message?.pr)
          return toast.error(err?.response?.data?.message?.pr, {
            position: "bottom-right"
          })
        else
          return toast.error("خطایی رخ داده است.", {
            position: "bottom-right"
          })
      }).finally(() => {
      })
  }, [reloadTour])
  useEffect(() => {
    allRoom(address,undefined,{ "markers": 0, "image": 0, "radio": 0}).then((result) => {
      let rooms = result.data.reverse()
      let r = [];
      rooms.forEach((item, index) => {
        if (index < 7)
          r.push(item)
      });
      if (r.length < 7)
        for (let i = 0; 7 - r.length; i++)
          r.push({})
      setRooms(roomData(r))
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }, [roomReload])
  useEffect(() => {
    allLanding(address).then((result) => {
      let landing = result.data
      if (!landing || !landing.active)
        setLandingStatus(false)
      else
        setLandingStatus(true)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }, [landingReload])
  useEffect(() => {
    allFiles("audio").then((result) => {
      let musics = result.data
      musics.unshift({
        _id: "default",
        filename: "پیش فرض",
        createdAt: "2023-07-30 10:10:10",
        path: "/music/default.mp3",
        size: 4776302,
        name: "پیش فرض"
      })
      setMusics(musics)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }, [])
  function Delete() {
    setIsDeleteTourLoading(true)
    deleteTour(address).then((result) => {
      history.push("/admin/tours")
    }).catch((err) => {
      console.error(err)
      onClose()
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsDeleteTourLoading(false)
    })
  }
  function changeLandingStatus(property, value) {
    editLanding(address, {
      [property]: value
    }).then((result) => {
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }
  function setTourMusic(music) {
    if (currentMusic) {
      currentMusic.new.pause()
      setCurrentMusic(null)

    }
    editTour(address, {
      music: {
        path: music?.path.replace("upload/user/", "/assets/users/"),
        date: music?.createdAt,
        filename: music?.filename,
        size: music?.size
      }
    }).then((result) => {
      setReloadTour(!reloadTour)
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }
  function changeTourProperty(property, value) {
    editTour(address, {
      [property]: value
    }).then((result) => {
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }
  function save() {
    setIsSaveLoading(true)
    let data = {
      'title': title
    }
    if (tourData.home?tourData.home:config.host != home){
      data.home = home
    }
    editTour(address, data).then((result) => {
      // Update tourData after successful save
      setTourData({
        ...tourData,
        title: title,
        home: data.home ? home : tourData.home
      })
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsSaveLoading(false)
    })
  }
  function saveLang() {
    setIsSaveLangLoading(true)
    let data = {
      'lang': lang
    }
    editTour(address, data).then((result) => {
      // Update tourData after successful save
      setTourData({
        ...tourData,
        lang: lang
      })
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsSaveLangLoading(false)
    })
  }
  function createRoomAction() {
    setIsCreateRoomLoading(true)
    createRoom(address, roomTitle).then((result) => {
      toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
      setRoomTitle("")
      setRoomReload(!roomReload);
      onRoomClose()
    }).catch((err) => {
      console.error(err)
      if (err?.response?.status == 409)
        return toast.error("آدرس انتخابی تکراری است.", {
          position: "bottom-right"
        })
      else
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsCreateRoomLoading(false)
    })
  }
  return (
    <Flex direction='column' pt={{ base: "120px", md: "75px" }}>
      <Grid templateColumns={{ sm: "1fr", lg: "2.0fr 1.2fr" }} gap='24px' alignItems='start'>
        <Box>
          <Card p='16px' mb='24px'>
            <CardHeader>
              <Flex
                direction={{ sm: "column", md: "row" }}
                justify='space-between'
                align='center'
                minHeight='60px'
                w='100%'>
                <Text fontSize='md' color={textColor} fontWeight='bold'>
                  <IconButton
                    _hover={{ color: "tomato" }}
                    color={textColor}
                    onClick={onOpen}
                    variant="no-effects"
                    aria-label="حذف نمایشگاه"
                    size="lg"
                    icon={<RiDeleteBin3Fill />}
                  />
                  نمایشگاه مجازی {tourData.title}
                </Text>
                <Box mt={{ sm: "30px", md: "0px" }}>
                  {
                    (landingStatus) ? <Button fontSize='xs' onClick={() => {
                      window.open(config.host + "/landing/" + address, '_blank', 'noopener,noreferrer');
                    }}
                    >
                      مشاهده لندینگ
                    </Button> : ""
                  }

                  <Button fontSize='xs' mr="4" onClick={() => {
                    window.open(config.host + "/tour/" + address, '_blank', 'noopener,noreferrer');
                  }} >مشاهده نمایشگاه</Button>
                </Box>
              </Flex>
              <Flex mt="12"
                direction={{ sm: "column", md: "row" }}
              >
                <FormControl w='100%' ml="5" id="tour-title">
                  <FormLabel fontSize="sm" >عنوان نمایشگاه</FormLabel>
                  <Input fontSize="xs" placeholder={tourData.title} value={title} onChange={e => setTitle(e.target.value)} />
                </FormControl>
                <FormControl w='100%' id="tour-home" mt={{ sm: "20px", md: "0px" }}>
                  <FormLabel fontSize="sm" >آدرس خانه <Icon h={"14px"} w={"14px"} mr="10px" color="gold" as={RiVipCrown2Fill} /></FormLabel>

                  <Input disabled={!me?.plan?.home} dir="ltr" value={home} fontSize="xs" onChange={e => setHome(e.target.value)} placeholder={tourData.home ? tourData.home : config.host} />
                </FormControl>
              </Flex>
              <Flex>
                <Spacer />
                <Box pt="10" w={{ sm: "100%", md: "auto" }} >
                  <ButtonGroup w="100%" textAlign="left">
                    <NiceButton
                      color={colorMode === "dark" ? "white" : "black"}
                      isLoading={isSaveLoading}
                      onClick={save}
                      fontSize='xs'
                      w='100%'
                    >
                      ذخیره
                    </NiceButton>
                  </ButtonGroup>
                </Box>

              </Flex>
            </CardHeader>
          </Card>
          <Grid templateColumns={{ sm: "1fr", md: "1fr 1fr" }} gap='26px' mb='24px'>
            <Card p='16px'>
              <CardHeader>
                <FormControl id="tour-lang">
                  <FormLabel fontSize="sm" >زبان</FormLabel>
                  <Flex gap="8px" mt="8px" flexWrap="wrap">
                    {[
                      { code: "pr", countryCode: "ir", title: "فارسی" },
                      { code: "en", countryCode: "us", title: "English" },
                      { code: "ru", countryCode: "ru", title: "Русский" },
                      { code: "uk", countryCode: "ua", title: "Українська" },
                      { code: "de", countryCode: "de", title: "Deutsch" },
                      { code: "zh", countryCode: "cn", title: "中文" },
                      { code: "ar", countryCode: "sa", title: "العربية" },
                      { code: "fr", countryCode: "fr", title: "Français" },
                      { code: "es", countryCode: "es", title: "Español" }
                    ].map((langItem) => (
                      <Box
                        key={langItem.code}
                        as="button"
                        w="40px"
                        h="40px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius="8px"
                        border={lang === langItem.code ? "2px solid" : "1px solid"}
                        borderColor={lang === langItem.code ? "blue.500" : borderColor}
                        bg={lang === langItem.code ? iconBgColor : "transparent"}
                        _hover={{ borderColor: "blue.400", bg: iconBgColor }}
                        cursor="pointer"
                        transition="all 0.2s"
                        onClick={() => setLang(langItem.code)}
                        title={langItem.title}
                        overflow="hidden"
                      >
                        <Image
                          src={`/vendor/media/${langItem.countryCode}.svg`}
                          alt={langItem.title}
                          w="100%"
                          h="100%"
                          objectFit="cover"
                          loading="lazy"
                        />
                      </Box>
                    ))}
                  </Flex>
                </FormControl>
              </CardHeader>
              <CardBody>
                <Flex>
                  <Spacer />
                  <Box pt="10" w={{ sm: "100%", md: "auto" }}>
                    <ButtonGroup w="100%" textAlign="left">
                      <NiceButton
                        color={colorMode === "dark" ? "white" : "black"}
                        isLoading={isSaveLangLoading}
                        onClick={saveLang}
                        fontSize='xs'
                        w='100%'
                      >
                        ذخیره
                      </NiceButton>
                    </ButtonGroup>
                  </Box>
                </Flex>
              </CardBody>
            </Card>
            <Card p='16px'>
              <CardHeader>
                <FormLabel fontSize="sm" ></FormLabel>
              </CardHeader>
              <CardBody>
                <Flex direction='column' gap='12px'>
                  <FormControl>
                    <FormLabel fontSize="xs" >لینک تور</FormLabel>
                    <Flex gap="8px">
                      <Input 
                        fontSize="xs" 
                        value={config.host + "/tour/" + address}
                        readOnly
                        disabled={true}
                        dir="ltr"
                      />
                      <IconButton
                        aria-label="کپی لینک"
                        icon={<RiFileCopyLine />}
                        onClick={() => {
                          navigator.clipboard.writeText(config.host + "/tour/" + address);
                          toast.success("لینک کپی شد", { position: "bottom-right" });
                        }}
                        fontSize='sm'
                      />
                    </Flex>
                  </FormControl>
                  <FormControl>
                    <FormLabel fontSize="xs" >کد جاسازی</FormLabel>
                    <Flex gap="8px">
                      <Input 
                        disabled={true}
                        fontSize="xs" 
                        value={`<iframe src="${config.host + "/tour/" + address}" width="640" height="480" frameborder="no" scrolling="no" allow="accelerometer; autoplay; gyroscope" allowfullscreen></iframe>`}
                        readOnly
                        dir="ltr"
                      />
                      <IconButton
                        aria-label="کپی کد"
                        icon={<RiFileCopyLine />}
                        onClick={() => {
                          const embedCode = `<iframe src="${config.host + "/tour/" + address}" width="640" height="480" frameborder="no" scrolling="no" allow="accelerometer; autoplay; gyroscope" allowfullscreen></iframe>`;
                          navigator.clipboard.writeText(embedCode);
                          toast.success("کد کپی شد", { position: "bottom-right" });
                        }}
                        fontSize='sm'
                      />
                    </Flex>
                  </FormControl>
                </Flex>
              </CardBody>
            </Card>
          </Grid>
          <Grid
            templateColumns={{
              sm: "1fr",
              md: "1fr 1fr",
              xl: "1fr 1fr 1fr 1fr",
            }}
            gap='26px'
            alignItems='stretch'>

            <Card p='16px' display='flex' align='center' justify='center' h='100%'>
              <CardBody h='100%' display='flex' flexDirection='column' justifyContent='space-between'>
                <Flex direction='column' align='center' w='100%' py='14px' justify='center'>
                  <IconBox as='box' h={"60px"} w={"60px"} bg={iconBgColor}>
                    <Icon h={"24px"} w={"24px"} color={iconBlue} as={FaLandmark} />
                  </IconBox>
                  <Flex
                    direction='column'
                    m='14px'
                    justify='center'
                    textAlign='center'
                    align='center'
                    w='100%'>
                    <Text fontSize='md' color={textColor}>
                      صفحه فرود
                    </Text>
                    <Text
                      fontSize='xs'
                      color='gray.400'>
                      صفحه‌ای پیش از ورود
                    </Text>
                    <Button onClick={() => {  tourData?history.push("/admin/landing/" + tourData.address + "/" + tourData.title):"" }} mt='10px' mb="3px" fontSize='xs' variant="no-effects" leftIcon={<RiSettings3Fill />}>تنظیمات</Button>
                  </Flex>
                </Flex>
                <Box>
                  <HSeparator mb="16px" />
                  <Box display='flex' justifyContent='center'>
                    <Switch
                      isChecked={landingStatus}
                      onChange={() => {
                        let value = !landingStatus
                        setLandingStatus(value)
                        changeLandingStatus("active", value)
                      }}
                      colorScheme="blue"
                    />
                  </Box>
                </Box>
              </CardBody>
            </Card>
            <Card p='16px' display='flex' align='center' justify='center' h='100%'>
              <CardBody h='100%' display='flex' flexDirection='column' justifyContent='space-between'>
                <Flex direction='column' align='center' w='100%' py='14px' justify='center'>
                  <IconBox as='box' h={"60px"} w={"60px"} bg={iconBgColor}>
                    <Icon h={"24px"} w={"24px"} color={iconBlue} as={RiMoonClearFill} />
                  </IconBox>
                  <Flex
                    direction='column'
                    m='14px'
                    justify='center'
                    textAlign='center'
                    align='center'
                    w='100%'>
                    <Text fontSize='sm' color={textColor}>
                      شب / روز
                    </Text>
                    <Text
                      fontSize='xs'
                      color='gray.400'>
                      امکان سوییچ کردن به نمای شب یا روز در همه ایستگاه‌ها
                    </Text>
                  </Flex>
                </Flex>
                <Box>
                  <HSeparator mb="16px" />
                  <Box display='flex' justifyContent='center'>
                    <Switch
                      isChecked={nightStatus}
                      onChange={() => {
                        let value = !nightStatus
                        setNightStatus(value)
                        changeTourProperty("night", value)
                      }}
                      colorScheme="blue"
                    />
                  </Box>
                </Box>
              </CardBody>
            </Card>
            <Card p='16px' display='flex' align='center' justify='center' h='100%'>
              <CardBody h='100%' display='flex' flexDirection='column' justifyContent='space-between'>
                <Flex direction='column' align='center' w='100%' py='14px' justify='center'>
                  <IconBox as='box' h={"60px"} w={"60px"} bg={iconBgColor}>
                    <Icon h={"24px"} w={"24px"} color={iconBlue} as={RiRemoteControl2Fill} />
                  </IconBox>
                  <Flex
                    direction='column'
                    m='14px'
                    justify='center'
                    textAlign='center'
                    align='center'
                    w='100%'>
                    <Text fontSize='sm' color={textColor}>
                      کنترل پنل
                    </Text>
                    <Text
                      fontSize='xs'
                      color='gray.400'>
                      نمایش یا عدم نمایش کنترل پنل در پایین صفحه
                    </Text>
                  </Flex>
                </Flex>
                <Box>
                  <HSeparator mb="16px" />
                  <Box display='flex' justifyContent='center'>
                    <Switch
                      isChecked={controlPanelStatus}
                      onChange={() => {
                        let value = !controlPanelStatus
                        setControlPanelStatus(value)
                        changeTourProperty("controlPanel", value)
                      }}
                      colorScheme="blue"
                    />
                  </Box>
                </Box>
              </CardBody>
            </Card>
            <Card p='16px' display='flex' align='center' justify='center' h='100%'>
              <CardBody h='100%' display='flex' flexDirection='column' justifyContent='space-between'>
                <Flex direction='column' align='center' w='100%' py='14px' justify='center'>
                  <IconBox as='box' h={"60px"} w={"60px"} bg={iconBgColor}>
                    <Icon h={"24px"} w={"24px"} color={iconBlue} as={RiRocketFill} />
                  </IconBox>
                  <Flex
                    direction='column'
                    m='14px'
                    justify='center'
                    textAlign='center'
                    align='center'
                    w='100%'>
                    <Text fontSize='sm' color={textColor}>
                      دسترسی سریع
                    </Text>
                    <Text
                      fontSize='xs'
                      color='gray.400'>
                      نمایش یا عدم نمایش دسترسی سریع ایستگاه‌ها
                    </Text>
                  </Flex>
                </Flex>
                <Box>
                  <HSeparator mb="16px" />
                  <Box display='flex' justifyContent='center'>
                    <Switch
                      colorScheme="blue"
                      isChecked={galleryStatus}
                      onChange={() => {
                        let value = !galleryStatus
                        setGalleryStatus(value)
                        changeTourProperty("gallery", value)
                      }}
                    />
                  </Box>
                </Box>
              </CardBody>
            </Card>
          </Grid>
          <Card my={{ lg: "24px" }}>
            <Flex direction='column'>
              <CardHeader py='12px'>
                <Text color={textColor} fontSize='md' fontWeight='bold'>
                  مدیریت ابزارک ها
                </Text>
              </CardHeader>
              <CardBody>
                <Grid
                  mt="24px"
                  templateColumns={{
                    sm: "1fr",
                    md: "1fr 1fr",
                    xl: "1fr 1fr 1fr 1fr",
                  }}
                  gap='16px'>
                  <Box
                    as="button"
                    p='16px'
                    borderRadius='12px'
                    border='1px solid'
                    borderColor={borderColor}
                    bg={widgetBg}
                    _hover={{ 
                      borderColor: "blue.400", 
                      bg: widgetHoverBg,
                      transform: 'translateY(-2px)',
                      boxShadow: 'md'
                    }}
                    transition='all 0.2s'
                    onClick={() => { tourData?history.push("/admin/menus/" + tourData.address + "/" + tourData.title):"" }}
                    cursor='pointer'
                    textAlign='left'
                  >
                    <Flex direction='row' align='center' gap='12px'>
                      <IconBox as='box' h={"40px"} w={"40px"} bg={widgetIconBg} borderRadius='8px'>
                        <Icon h={"20px"} w={"20px"} color={iconBlue} as={RiMenuLine} />
                      </IconBox>
                      <Flex direction='column' align='flex-start' flex='1'>
                        <Text fontSize='sm' color={textColor} fontWeight='semibold' mb='4px'>
                          منوها
                        </Text>
                        <Text fontSize='xs' color='gray.400' noOfLines={1}>
                          مدیریت منوها
                        </Text>
                      </Flex>
                    </Flex>
                  </Box>
                  <Box
                    as="button"
                    p='16px'
                    borderRadius='12px'
                    border='1px solid'
                    borderColor={borderColor}
                    bg={widgetBg}
                    _hover={{ 
                      borderColor: "blue.400", 
                      bg: widgetHoverBg,
                      transform: 'translateY(-2px)',
                      boxShadow: 'md'
                    }}
                    transition='all 0.2s'
                    onClick={() => {  tourData?history.push("/admin/popups/" ):"" }}
                    cursor='pointer'
                    textAlign='left'
                  >
                    <Flex direction='row' align='center' gap='12px'>
                      <IconBox as='box' h={"40px"} w={"40px"} bg={widgetIconBg} borderRadius='8px'>
                        <Icon h={"20px"} w={"20px"} color={iconBlue} as={RiLayoutTop2Fill} />
                      </IconBox>
                      <Flex direction='column' align='flex-start' flex='1'>
                        <Text fontSize='sm' color={textColor} fontWeight='semibold' mb='4px'>
                          پاپ‌آپ‌ها
                        </Text>
                        <Text fontSize='xs' color='gray.400' noOfLines={1}>
                          مدیریت پاپ‌آپ‌ها
                        </Text>
                      </Flex>
                    </Flex>
                  </Box>
                  <Box
                    as="button"
                    p='16px'
                    borderRadius='12px'
                    border='1px solid'
                    borderColor={borderColor}
                    bg={widgetBg}
                    _hover={{ 
                      borderColor: "blue.400", 
                      bg: widgetHoverBg,
                      transform: 'translateY(-2px)',
                      boxShadow: 'md'
                    }}
                    transition='all 0.2s'
                    onClick={onFeedOpen}
                    cursor='pointer'
                    textAlign='left'
                  >
                    <Flex direction='row' align='center' gap='12px'>
                      <IconBox as='box' h={"40px"} w={"40px"} bg={widgetIconBg} borderRadius='8px'>
                        <Icon h={"20px"} w={"20px"} color={iconBlue} as={RiNewspaperFill} />
                      </IconBox>
                      <Flex direction='column' align='flex-start' flex='1'>
                        <Text fontSize='sm' color={textColor} fontWeight='semibold' mb='4px'>
                          اخبار فوری
                        </Text>
                        <Text fontSize='xs' color='gray.400' noOfLines={1}>
                          مدیریت اخبار
                        </Text>
                      </Flex>
                    </Flex>
                  </Box>
                  <Box
                    as="button"
                    p='16px'
                    borderRadius='12px'
                    border='1px solid'
                    borderColor={borderColor}
                    bg={widgetBg}
                    _hover={{ 
                      borderColor: "blue.400", 
                      bg: widgetHoverBg,
                      transform: 'translateY(-2px)',
                      boxShadow: 'md'
                    }}
                    transition='all 0.2s'
                    onClick={() => {  tourData?history.push("/admin/chatrooms/" + tourData.address + "/" + tourData.title):"" }}
                    cursor='pointer'
                    textAlign='left'
                  >
                    <Flex direction='row' align='center' gap='12px'>
                      <IconBox as='box' h={"40px"} w={"40px"} bg={widgetIconBg} borderRadius='8px'>
                        <Icon h={"20px"} w={"20px"} color={iconBlue} as={RiChat1Fill} />
                      </IconBox>
                      <Flex direction='column' align='flex-start' flex='1'>
                        <Text fontSize='sm' color={textColor} fontWeight='semibold' mb='4px'>
                          چت‌روم
                        </Text>
                        <Text fontSize='xs' color='gray.400' noOfLines={1}>
                          مدیریت چت‌روم
                        </Text>
                      </Flex>
                    </Flex>
                  </Box>
                </Grid>
              </CardBody>
            </Flex>
          </Card>
        </Box>
        <Box>
          <Card
            p='22px'
            mb='24px'>
            <CardHeader>
              <Flex justify='space-between' align='center' mb='1rem' w='100%'>
                <Text fontSize='md' color={textColor} fontWeight='bold'>
                  مدیریت ایستگاه‌ها
                </Text>
                <Button
                  onClick={onRoomOpen}
                  variant='outlined'
                  color={colorMode === "dark" && "white"}
                  _hover={colorMode === "dark" && "none"}
                  borderColor={colorMode === "dark" && "white"}
                  minW='110px'
                  maxH='35px'>
                  ساخت ایستگاه جدید
                </Button>
              </Flex>
            </CardHeader>
            <CardBody>
              <Flex direction='column' w='100%'>
                {
                  rooms && rooms?.map((row, idx) => {
                    return (
                      <RoomRow
                        active={row.active}
                        id={row.id}
                        title={row.name}
                        logo={RiArrowLeftSLine}
                        date={moment(row.date).format('jYYYY-jM-jD HH:mm:ss')}
                        format={row.format}
                        address={address}
                        key={idx}
                      />
                    );
                  })}

                <Grid>
                  <Button onClick={() => { history.push("/admin/rooms/" + tourData.address + "/" + tourData.title) }} fontSize="xs">مشاهده همه</Button>
                </Grid>
              </Flex>
            </CardBody>
          </Card>
          <Card>
            <CardHeader mb='12px'>
              <Flex direction='column' w='100%'>
                <Flex
                  direction={{ sm: "column", lg: "row" }}
                  justify={{ sm: "center", lg: "space-between" }}
                  w='100%'
                  my={{ md: "12px" }}>
                  <Text
                    color={textColor}
                    fontSize='md'
                    fontWeight='bold'>
                    موسیقی نمایشگاه
                  </Text>
                </Flex>
              </Flex>
            </CardHeader>
            <CardBody>
              <Flex mt="10px" direction='column' w='100%'>
                <Text
                  color='gray.400'
                  fontSize="xs"
                  mt="20px"
                  my='12px'>
                  انتخاب شده
                </Text>
                {choosedMusic.map((row, idx) => {
                  return (
                    <MusicRow
                      color="green.500"
                      name={row.name}
                      logo={currentMusic?._id == row._id ? RiPauseMiniLine : RiPlayFill}
                      playaction={() => playaction(row)}
                      date={moment(row.createdAt).format('jYYYY-jM-jD HH:mm:ss')}
                      price={row.price}
                      key={idx}
                      action={<Button onClick={() => setTourMusic(null)} variant="no-effects" color={"red.400"} fontSize="xs" >
                        حذف
                      </Button>}
                    />
                  );
                })}
                <HSeparator mt="30px" mb="30px" />
                <Text
                  color='gray.400'
                  fontSize="xs"
                  mt="20px"
                  my='12px'>
                  انتخاب از فایل های موسیقی آپلود شده
                </Text>
                {musics && musics.slice(0, 3).map((row, idx) => {
                  return (
                    <MusicRow
                      name={row.filename}
                      logo={currentMusic?._id == row._id ? RiPauseMiniLine : RiPlayFill}
                      playaction={() => playaction(row)}
                      address={config.host + (row.path.replace("upload/user/", "/assets/users/"))}
                      date={moment(row.createdAt).format('jYYYY-jM-jD HH:mm:ss')}
                      key={idx}
                      action={<Button onClick={() => setTourMusic(row)} variant="no-effects" color={"gray.400"} fontSize="xs" >
                        انتخاب
                      </Button>}
                    />
                  );
                })}
                <Grid>
                  <Button onClick={onMusicOpen} fontSize="xs">مشاهده همه</Button>
                </Grid>
              </Flex>
            </CardBody>
          </Card>
        </Box>
      </Grid>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center" fontSize="md">حذف نمایشگاه</ModalHeader>
          <ModalCloseButton />
          <ModalBody fontSize="xs">
            حذف نمایشگاه باعث خواهد شد همه اطلاعات و تنظیمات آن به صورت بی بازگشت حذف شود. مطمئنید؟
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose} fontSize='xs'>خیر</Button>
            <NiceButton mr="10px"
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isDeleteTourLoading}
              onClick={Delete}
              fontSize='xs'
              w="100px"
            >
              بله
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isRoomOpen} onClose={onRoomClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize={"md"} textAlign="center" >ساخت ایستگاه جدید</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mt={"20px"} id="title">
              <FormLabel  fontSize={"xs"} >عنوان (فارسی)</FormLabel>
              <Input value={roomTitle} fontSize={"xs"} onChange={e => setRoomTitle(e.target.value)} type="text" />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <NiceButton
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isCreateRoomLoading}
              onClick={createRoomAction}
              fontSize='xs'
              w="100px"
            >
              ثبت
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isMusicOpen} onClose={() => { onMusicClose(), stopMusic() }}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize={"md"} textAlign="center" >نمایش همه فایل‌های موسیقی</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Scrollbars dir="ltr" autoHeightMin={0}
              autoHide
              autoHideTimeout={1000}
              autoHideDuration={200}
              hideTracksWhenNotNeeded={true}
              autoHeight
              autoHeightMax={490} >
              <Grid dir="rtl" pr="20px">
                {musics && musics.map((row, idx) => {
                  return (
                    <MusicRow
                      name={row.filename}
                      logo={currentMusic?._id == row._id ? RiPauseMiniLine : RiPlayFill}
                      playaction={() => playaction(row)}
                      address={config.host + (row.path.replace("upload/user/", "/assets/users/"))}
                      date={moment(row.createdAt).format('jYYYY-jM-jD HH:mm:ss')}
                      key={idx}
                      action={<Button onClick={() => setTourMusic(row)} variant="no-effects" color={"gray.400"} fontSize="xs" >
                        انتخاب
                      </Button>}
                    />
                  );
                })}
              </Grid>
            </Scrollbars>
          </ModalBody>
          <ModalFooter>
            <NiceButton
              onClick={() => {
                onMusicClose();
                stopMusic();
                history.push("/admin/files?tab=3");
              }}
              variant="no-effects"
              colorScheme="blue"
              fontSize="sm"
            >
              رفتن به صفحه فایل‌ها (بخش صوت)
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isFeedOpen} onClose={onFeedClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize={"md"} textAlign="center">خبر فوری</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Scrollbars dir="ltr" autoHeightMin={0}
              autoHide
              autoHideTimeout={1000}
              autoHideDuration={200}
              hideTracksWhenNotNeeded={true}
              autoHeight
              autoHeightMax={490} >
              <Grid dir="rtl" pr="20px">
                <Feed setFeedData={setFeedData} defaultData={()=>{
                    let array=[]
                    tourData.feed?.list?.map((item)=>{
                      array.push({ quotation: item?.quotation, text: item?.text, href: item?.href })
                    })
                    return array
                }} mt={"20px"} title={tourData.feed?.title} />
              </Grid>
            </Scrollbars>

          </ModalBody>
          <ModalFooter>
            <NiceButton
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isCreateRoomLoading}
              onClick={feedSubmit}
              fontSize='xs'
              w="100px">
              ثبت
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

export default TourDetails;
